export const createLatLng = (latitude, longitude) => {
  return new window.google.maps.LatLng(latitude, longitude)
};

export const createMarker = (options) => {
  return new window.google.maps.Marker({
    map: options.map,
    position: createLatLng(options.latitude, options.longitude),
    title: options.title,
    icon: options.iconURL,
  });
};

let _autoBoundsCall = true;

export const createMap = (domElement, options) => new window.google.maps.Map(domElement, options);

export const addMapListener = (map, event, callback) => window.google.maps.event.addListener(map, event, () => {
  callback(_autoBoundsCall);
  if (_autoBoundsCall) {
    _autoBoundsCall = false;
  };
});

export const createNewOverlay = () => new window.google.maps.OverlayView();
export const computeHeading = (oldLatLng, newLatLng) => window.google.maps.geometry.spherical.computeHeading(oldLatLng, newLatLng);

export const turnOnAutoBounds = (bounds, padding, context) => {
  _autoBoundsCall = true;
};

export const createLatLngBounds = () => {
  return new window.google.maps.LatLngBounds();
};

export const decodePolyline = (encodedPath) => {
  return window.google.maps.geometry.encoding.decodePath(encodedPath);
}

export const createPolylineFromLatLngList = (segmentsCoordinates) => {
  return new window.google.maps.Polyline({
    path: segmentsCoordinates,
  });
};

export const distanceBetweenPoints = (point1, point2) => window.google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
export const computeOffset = (from, distance, heading) => window.google.maps.geometry.spherical.computeOffset(from, distance, heading);

export const createCircle = (latitude, longitude) => {
  return new window.google.maps.Circle({
    strokeColor: "#ff0000",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#FF0000",
    fillOpacity: 1,
    center: createLatLng(latitude, longitude),
    radius: 10,
  });
}